const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
const API_BASE = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export async function uploadImage(file, accessToken) {
  if (!(file instanceof Blob)) {
    throw new Error('Expected a File or Blob.');
  }

  const mediaType = file.type === 'image/jpg' ? 'image/jpeg' : file.type;
  if (!mediaType || !mediaType.startsWith('image/')) {
    throw new Error('Only image/* types are allowed.');
  }

  const mediaSize = file.size;

  if (mediaSize > MAX_IMAGE_BYTES) {
    throw new Error('Image must be 10MB or smaller.');
  }
  if (mediaSize === 0) {
    throw new Error('Image file is empty.');
  }

  const token = accessToken || localStorage.getItem('access_token');
  if (!token) {
    throw new Error('Not authenticated. Please log in again.');
  }

  const response = await fetch(`${API_BASE}/media/presigned-url`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ mediaType, mediaSize }),
  });

  let body;
  try {
    body = await response.json();
  } catch {
    throw new Error('Failed to get upload URL.');
  }

  if (!response.ok || body?.success === false) {
    throw new Error(body?.message || 'Failed to get upload URL.');
  }

  const data = body.data || {};
  const key = data.key;
  const url = data.url;

  if (!key || !url) {
    throw new Error('Invalid presign response: missing key or url.');
  }

  const putResponse = await fetch(url, {
    method: 'PUT',
    body: file,
  });

  if (!putResponse.ok) {
    throw new Error('Upload failed. Could not store the image in S3.');
  }

  return { key, url };
}

export async function getMediaViewUrl(key, accessToken) {
  const token = accessToken || localStorage.getItem('access_token');
  if (!token || !key) return null;

  const response = await fetch(
    `${API_BASE}/media/view-url?key=${encodeURIComponent(key)}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  let body;
  try {
    body = await response.json();
  } catch {
    return null;
  }

  if (!response.ok || body?.success === false) return null;
  return typeof body.data === 'string' ? body.data : body.data?.url || null;
}